import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        style: {
          background: "var(--gz-primary)",
          color: "#ffffff",
          border: "1px solid rgba(255,255,255,0.14)",
          borderRadius: "14px",
          fontFamily: '"Jost", ui-sans-serif, system-ui, sans-serif',
          fontSize: "14px",
          padding: "14px 16px",
        },
        classNames: {
          toast: "gz-toast",
          title: "font-semibold tracking-tight",
          description: "text-white/75",
          actionButton: "bg-white !text-[#001393] font-semibold rounded-lg",
          cancelButton: "bg-white/15 text-white rounded-lg",
          closeButton:
            "!bg-white/15 !text-white !border-white/25 hover:!bg-white/25",
          icon: "text-white",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
